const currencyFormatters = new Map<string, Intl.NumberFormat>();
const dateFormatter = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'long' });
const percentFormatter = new Intl.NumberFormat('fr-FR', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 3 });
const eurosFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

function currencyFormatter(currency: string): Intl.NumberFormat {
  let formatter = currencyFormatters.get(currency);
  if (!formatter) {
    formatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency });
    currencyFormatters.set(currency, formatter);
  }
  return formatter;
}

/** `currency` : code ISO du bien (`Property['currency']`) — jamais implicitement l'euro. */
export function formatCents(cents: number, currency: string): string {
  return currencyFormatter(currency).format(cents / 100);
}

/** `AAAA-MM-JJ` → date longue en français. `null` : pas encore acquis / pas de date. */
export function formatIsoDate(isoDate: string | null): string {
  if (isoDate === null) return '—';
  // Interprété en UTC pour éviter qu'un fuseau à l'ouest ne fasse reculer la date d'un jour.
  return dateFormatter.format(new Date(`${isoDate}T00:00:00Z`));
}

/** Taux en décimal (`0,0387`) → pourcentage affiché (`3,87 %`). `null` : indicateur non applicable (`n.a`). */
export function formatRatio(ratio: number | null): string {
  return ratio === null ? 'n.a' : percentFormatter.format(ratio);
}

/**
 * Montant en euros, pas en centimes : le moteur financier (`@app/finance`) travaille en
 * float64, jamais en cents — contrairement au reste de l'application. `null` : `n.a`.
 * `-0 + 0` : le moteur additionne des charges nulles obtenues par négation (`-0 * taux`),
 * et `Intl.NumberFormat` afficherait littéralement « -0,00 € » sans ce recalage.
 */
export function formatEuros(value: number | null): string {
  return value === null ? 'n.a' : eurosFormatter.format(value === 0 ? 0 : value);
}
